








import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { AssetsModule, SingleAssetUsage, isSelectable } from '@/store/modules/asset'
import { ErrorsModule } from '@/store/modules/error'
import { ToolbarModule } from '@/store/modules/toolbar'
import PrimaryButtons from '@/components/common/PrimaryButtons.vue'
import DesignPaintingImage from "@/components/products/malennachzahlen/steps/DesignPaintingImage.vue"
import PaintingOverlayUpload from "@/components/products/malennachzahlen/steps/PaintingOverlayUpload.vue"
import { PaintingByNumbersModule, PaintingBoxUpdateState, PaintingInfo } from '@/store/modules/paintingByNumbers'
import { AppModule} from '@/store/modules/app'

@Component({
    name: 'design-painting',
    components: {
        PrimaryButtons,
        DesignPainting,
        DesignPaintingImage,
        PaintingOverlayUpload,
    },
})

export default class DesignPainting extends Vue{
    @Prop() private optional!: boolean

    public displayOverlayUpload = false
    private oldFormat = PaintingByNumbersModule.format
    private oldUserFormat = PaintingByNumbersModule.userFormat
    private confirmableImage = false

    get showOverlayUpload() {
        return PaintingByNumbersModule.overlayUploadVisibe
    }

    get filesLoading() {
        let filesLoading = false
        AssetsModule.assets.forEach(file => {
            if (!isSelectable(file)) {
                filesLoading = true
            }
        })
      return filesLoading
    }

    @Watch('showOverlayUpload')
    showOverlayUploadChanged(newShowoverlayUpload: boolean) {
        this.displayOverlayUpload = newShowoverlayUpload
    }

    mounted() {
        this.persistPainting()
    }

    persistPainting() {
        Object.keys(PaintingByNumbersModule.persistedAssets).forEach(key => {
            PaintingByNumbersModule.ClearPersistedAssetData(key)
        })
        Object.keys(PaintingByNumbersModule.activeAssets).forEach(key => {
            let asset = PaintingByNumbersModule.activeAssets[key]
            let usage = asset.usage[key] as SingleAssetUsage
            let info = PaintingByNumbersModule.paintingUsageAndInfo[key] as PaintingInfo
            if (info !== undefined && usage !== undefined && asset !== undefined) {
                PaintingByNumbersModule.SetPersistedAsset([key, asset])
                PaintingByNumbersModule.PersistNameAndUsage([key, usage])
                PaintingByNumbersModule.PersistPaintingUsageAndInfo([key, info])
            }
        })
    }

    recoverPainting() {
        PaintingByNumbersModule.SetRecoverPaintingToggled(!PaintingByNumbersModule.recoverPaintingToggled)
    }

    canceloverlayUpload() {
        (this.$refs.overlayUpload as PaintingOverlayUpload).onCancel()
    }

    closeoverlayUpload() {
        (this.$refs.overlayUpload as PaintingOverlayUpload).onClose()
    }

    confirmPaintingImage() {
        (this.$refs.paintingImage as DesignPaintingImage).confirm()
    }

    onCancel() {
        if (ToolbarModule.error) {
            ToolbarModule.SetToolbarError(false)
        }
        if (ToolbarModule.errorKeys.length > 0) {
            ToolbarModule.UnsetErrorKey("paintingimage")
            }
        if (ErrorsModule.keys.length > 0) {
            ErrorsModule.SetError({ key: "paintingimage" })
        }
        PaintingByNumbersModule.SetPaintingBoxUpdateState(PaintingBoxUpdateState.UPDATED)
        PaintingByNumbersModule.SetShowOverlayUpload(false)
        this.recoverPainting()
        PaintingByNumbersModule.SetPaintingFormat(this.oldFormat)
        PaintingByNumbersModule.SetUserFormat(this.oldUserFormat)
        this.canceloverlayUpload()
        this.$emit('cancel')
    }

    onConfirm() {
        if (this.confirmableImage) {
            if (this.oldFormat !== PaintingByNumbersModule.format) {
                PaintingByNumbersModule.SetResetBoxDesignToggled(!PaintingByNumbersModule.resetBoxDesignToggled)
            }
            this.confirmPaintingImage()
            this.$nextTick(() => {
                this.$emit('confirm')
                PaintingByNumbersModule.SetShowOverlayUpload(false)
                if (!AppModule.steps[0].completed){
                    AppModule.CompleteStep(0)
                }
                return
            })
        }
    }

    onClose() {
        PaintingByNumbersModule.SetShowOverlayUpload(false)
    }

    onConfirmableImageChanged(confirmable: boolean){
        this.confirmableImage = confirmable
    }

    confirmable() {
        return this.confirmableImage
    }

    goToMenu() {
        this.onCancel()
    }
}
